import { useTranslation } from 'react-i18next';

import { AgentMessageCard } from '../AgentMessageCard/AgentMessageCard';

type AgentEnrichmentFailureContentProps = {
  description?: string;
  onRetry?: () => void;
};

const AgentEnrichmentFailureContent = ({ description, onRetry }: AgentEnrichmentFailureContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 p-3">
      <AgentMessageCard
        description={description ?? t('webedi:sidebar.agents.enrichmentFailureIntro')}
        actions={
          onRetry
            ? [
                {
                  label: t('webedi:sidebar.agents.enrichDocuments.error.retryButton'),
                  onClick: onRetry,
                  analyticsId: 'webedi:agent_retry_enrichment_failure',
                },
              ]
            : undefined
        }
      />
    </div>
  );
};

export { AgentEnrichmentFailureContent };
